__turbopack_context__.v({
  "consentBox": "VyoQAG_consentBox",
  "consentButtons": "VyoQAG_consentButtons",
});
